import {useContext, useEffect} from "react";
import {AppContext} from "../../AppContext";
import {useRecoilState} from "recoil";
import {memberState} from "../../state/atoms";
import "./ItemLibraryPage.scss";

export function ItemLibraryPage() {
  const {location} = useContext(AppContext);
  const [member] = useRecoilState(memberState);

  useEffect(() => {
    const container = document.getElementById("item-library-page");
    if (container) {
      window.ItemLibrary.Lib.showAt({
        container,
        memberId: member.internalId,
        memberShowItemLibrary: member.showItemLibrary,
        locationId: location?.internalId ?? 0,
        presentation: "full"
      });
    }
  }, [member, location]);

  useEffect(() => {
    return () => {
      document.body.style.removeProperty("overflow");
    }
  }, []);

  return <>
    <div id={"item-library-page"}>

    </div>
  </>
}
